import axiosInstance from "@/axios";
import {
  createEqualParam,
  createParams,
} from "@/utils/searchQueryParamBuilder";
import { generateFilterQuery } from "@/utils/rsql";
import { isEmpty, map, values } from "@/utils/lodash";

const defaultSort = {
  proposalId: {
    sortingPath: "proposal.id",
    sortType: "DESC",
  },
  id: {
    sortingPath: "id",
    sortType: "DESC",
  },
};

const hiddenAndFavoritesDefaultSort = {
  dateAdded: {
    sortingPath: "dateAdded",
    sortType: "DESC",
  },
};

export const getPurchases = ({
  url,
  profileId,
  page,
  customFilters,
  currentTab,
  isActiveSearch,
  size,
  sort,
  filterId,
}) => {
  const sortBy = isEmpty(sort)
    ? currentTab.filterType === "HIDDEN" || currentTab.filterType === "TAG"
      ? hiddenAndFavoritesDefaultSort
      : defaultSort
    : sort;
  return axiosInstance.post(
    `api/collection${url}${createParams(
      createEqualParam("profileId", profileId),
      createEqualParam("page", page),
      createEqualParam("size", size),
      createEqualParam(
        "isActiveSearch",
        currentTab.filterType === "HIDDEN" || currentTab.filterType === "TAG"
          ? false
          : isActiveSearch,
      ),
      createEqualParam("filterId", filterId),
      ...(url === "/markedLots"
        ? [createEqualParam("markId", currentTab.id)]
        : []),
      ...map(values(sortBy), (it) =>
        createEqualParam("sort", `${it.sortingPath},${it.sortType}`),
      ),
    )}`,
    {
      query: generateFilterQuery(customFilters, currentTab.searchCriteria),
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const getAllLots = (proposalId, profileId) => {
  return axiosInstance.get(
    `/api/collection/lotsByProposal/${proposalId}?profileId=${profileId}`,
  );
};

export const createFavoriteLot = (favoriteLotData) => {
  return axiosInstance.post(
    `/api/profile/favoriteLots?projection=favoriteLotProjection`,
    favoriteLotData,
  );
};

export const removeFavoriteLot = (favoriteLotId) => {
  return axiosInstance.delete(`/api/profile/favoriteLots/${favoriteLotId}`);
};

export const addLotsToHidden = (hiddenLotData) => {
  return axiosInstance.post(`/api/profile/hiddenLots`, hiddenLotData);
};

export const removeLotsFromHidden = (hiddenLotData) => {
  return axiosInstance.delete(`/api/profile/hiddenLots`, {
    data: hiddenLotData,
  });
};
